import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import CloseIcon from '@material-ui/icons/Close'

import { makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import Select from '@material-ui/core/Select'
import Chip from '@material-ui/core/Chip'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'

import { Spin } from 'antd'

import { LoadingOutlined } from '@ant-design/icons'
import DeleteIcon from '@material-ui/icons/Delete'

import DeleteDialog from './DeleteDialog'
import ShareDialog from './ShareDialog'
import UsersListDialog from './UsersListDialog'
import RpcApiClient from 'datasources/RpcApiClient'
// import { socket } from 'datasources/Socket'

import './downloadFiles.css'

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: 200,
    // margin: 'auto',
    '& .MuiOutlinedInput-root': {
      height: 37,
    },
    '& .MuiSelect-outlined': {
      height: 37,
    },
    '& .MuiSelect-select': {
      height: 17,
      maxWidth: 200,
      padding: '0px 40px 0px 10px;',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 12px) scale(1) !important;',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75) !important;',
    },
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
  userList: {
    '& .MuiListItemText-primary': {
      fontSize: '14px',
      maxWidth: '200px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .MuiListItemText-secondary': {
      fontSize: '12px',
      maxWidth: '200px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
}))

function SavedFiles(props) {
  const authData = useSelector((state) => state.auth.authData)
  const userCompany = useSelector((state) => state.companyState.id)
  const userCompanyName = useSelector((state) => state.companyState.name)

  const [loadingScreen, setLoadingScreen] = useState(true)
  const [loading, setLoading] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [openShare, setOpenShare] = useState(false)
  const [openList, setOpenList] = useState(false)
  const [fileList, setFileList] = useState([])
  const [fileListCopy, setFileListCopy] = useState([])
  const [userList, setUserList] = useState([])
  const [alerta, setAlerta] = useState({ bool: false, message: 'Click the download button to start' })
  const [added, setAdded] = useState([])
  const [selectedFile, setSelectedFile] = useState('')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [searchlbl, setSearchlbl] = useState('')
  const [sharedUsers, setSharedUsers] = useState([])
  const [type, setType] = useState('')

  const classes = useStyles()

  useEffect(() => {
    getUserList()
    getFiles()
    setInterval(() => {
      getFiles()
    }, 300000)
    // }, 60000)
  }, [])

  useEffect(() => {
    props.addFeatures(added)
  }, [added])

  const columns = [
    { id: 'name', label: 'Name', minWidth: 170 },
    { id: 'type', label: 'Type', minWidth: 100 },
    { id: 'action', label: 'Delete', minWidth: 100 },
    { id: 'display', label: 'Select', minWidth: 100 },
  ]

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const handleFilter = (filter) => {
    if (filter !== undefined) {
      // console.log(usersTable)
      setSearchlbl(filter.target.value)
      setFileList(
        type === ''
          ? fileListCopy.filter((obj) => obj.name.toLowerCase().includes(filter.target.value.toLowerCase()))
          : fileListCopy.filter(
              (obj) => obj.name.toLowerCase().includes(filter.target.value.toLowerCase()) && obj.type.includes(type),
            ),
      )
    }
  }

  const handleTypeFilter = (filter) => {
    //console.log(fileListCopy)
    if (filter !== undefined) {
      setType(filter)
      setFileList(
        searchlbl.trim() === ''
          ? fileListCopy.filter((obj) => obj.type.includes(filter))
          : fileListCopy.filter(
              (obj) => obj.type.includes(filter) && obj.name.toLowerCase().includes(searchlbl.toLowerCase()),
            ),
      )
    }
  }

  const getUserList = async () => {
    try {
      const body = {
        company: userCompanyName,
      }
      const response = await RpcApiClient.getUserList(authData.jwtToken, body)
      setUserList(response.data.data)
      // console.log(response.data.data.filter(usr => usr.email !== authData.email))
    } catch (err) {
      console.log(err)
    }
  }

  const getFiles = async () => {
    setFileList([])
    const allFiles = []
    try {
      const body = {
        company: userCompany,
        client_email: authData.email,
        plan: '',
        country: 'Mexico',
        files: [],
      }
      const response = await RpcApiClient.getFiles(authData.jwtToken, body)
      response.data.body.map((file) => allFiles.push(file))
    } catch (err) {
      console.log(err)
    }
    setFileList(allFiles)
    setFileListCopy(allFiles)
    setLoadingScreen(false)
  }

  const handleToggle = (event, id) => {
    const files = fileList.map((data) => {
      if (data.id === id) {
        if (!isInFiles(data.name)) {
          if (!isBlocked(data)) {
            data.selected = event ? false : true
            data.isIn = false
            setAlerta({ bool: false, message: 'Click the download button to start' })
          }
        } else {
          data.isIn = true
          setAlerta({
            bool: true,
            message: `The ${data.name.replace(
              '.geojson',
              '',
            )} project is already downloaded or you have a project with the same name`,
          })
        }
      }
      return data
    })
    setFileList(files)
  }

  const validations = (name) => {
    const condition = (element) => element.projectName === name

    return props.projects.some(condition)
  }

  const isInFiles = (name) => {
    const condition = (element) => element.projectName === name.replace('.geojson', '')
    return props.projects.some(condition)
  }

  const isBlocked = (data) => {
    if (data.blocked) {
      const serverDate = Date.parse(data.timestamp) + 300000
      // const serverDate=Date.parse(data.timestamp)+(60000)
      const localDate = Date.parse(
        new Date().toLocaleString('en-CA', { timeZone: 'UTC', hour12: false }).replace(',', ''),
      )
      if (serverDate > localDate) {
        setAlerta({ bool: true, message: `The ${data.name} project is in use` })
        return true
      }
      if (serverDate < localDate) return false
    }
  }

  const downloadFiles = () => {
    const selected = []
    const selectedPrivate = []

    fileList.map((data) => {
      // console.log(data)
      if (data.selected && data.type === 'public') {
        selected.push({ key: data.id + '.geojson', name: data.name, dynamo_id: data.id })
      }
      if (data.selected && data.type === 'private') {
        selectedPrivate.push({ key: data.id + '.geojson', name: data.name, dynamo_id: data.id })
      }
      if (data.selected && data.type === 'shared') {
        selected.push({ key: data.id + '.geojson', name: data.name, dynamo_id: data.id })
      }
    })

    const body = {
      company: userCompany,
      // "client_email": "david.sanchez@tycho.solutions",
      plan: '',
      country: 'Mexico',
      files: selected,
    }
    const bodyPrivate = {
      company: userCompany,
      client_email: authData.email,
      plan: '',
      country: 'Mexico',
      files: selectedPrivate,
    }

    if (selected.length !== 0 || selectedPrivate.length !== 0) {
      addFeatures(body, bodyPrivate)
      setLoading(true)
      setAlerta({ bool: false, message: 'Click the download button to start' })
    } else {
      setAlerta({ bool: true, message: 'Select at least one file to start' })
    }
  }

  const addFeatures = async (body, bodyPrivate) => {
    try {
      const response = await RpcApiClient.getFileContent(authData.jwtToken, body)
      const responsePrivate = await RpcApiClient.getFileContent(authData.jwtToken, bodyPrivate)

      response.data.body.map((values) => {
        //console.log(values)
        if (!validations(values.name)) {
          values.content[0].features.map((data) => {
            data.properties.colorCode ? (data.properties.colorCode = JSON.parse(data.properties.colorCode)) : null
            data.properties.colorCodeB ? (data.properties.colorCodeB = JSON.parse(data.properties.colorCodeB)) : null
          })
          setAdded(values.content[0].features)
          props.setProjects((prevState) => {
            return [
              ...prevState,
              { project_id: values.id, projectName: values.name, visible: true, active: false, height: true, s3: true },
            ]
          })
        }
      })

      responsePrivate.data.body.map((values) => {
        // console.log(values)
        if (!validations(values.name)) {
          values.content[0].features.map((data) => {
            data.properties.colorCode ? (data.properties.colorCode = JSON.parse(data.properties.colorCode)) : null
            data.properties.colorCodeB ? (data.properties.colorCodeB = JSON.parse(data.properties.colorCodeB)) : null
            data.properties.dottedLine && !Array.isArray(data.properties.dottedLine)
              ? (data.properties.dottedLine = JSON.parse(data.properties.dottedLine))
              : null
          })
          setAdded(values.content[0].features)
          props.setProjects((prevState) => {
            return [
              ...prevState,
              { project_id: values.id, projectName: values.name, visible: true, active: false, height: true, s3: true },
            ]
          })
        }
      })
      setLoading(false)
      props.setDownloadCloudModal(false)
    } catch (err) {
      setLoading(false)
      console.log(err)
      setAlerta({ bool: true, message: 'Something went wrong. Please try again.' })
    }
  }

  if (!loadingScreen) {
    return (
      <div className="download-files-body">
        <IconButton
          size="small"
          component="span"
          onClick={() => props.setDownloadCloudModal(false)}
          className="sf-modal-close"
        >
          <CloseIcon />
        </IconButton>
        <h3>Project Admin</h3>
        <div style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
          <TextField
            label="Search by Name"
            size="small"
            variant="outlined"
            onChange={(e) => handleFilter(e)}
            value={searchlbl}
          />

          <FormControl variant="outlined" style={{ width: '100px' }} className={classes.formControl}>
            <InputLabel>Type</InputLabel>
            <Select
              // value={share}
              onChange={(e) => handleTypeFilter(e.target.value)}
              autoWidth={true}
              label="Share"
            >
              <MenuItem value={'public'} style={{ fontSize: '14px' }}>
                Public
              </MenuItem>
              <MenuItem value={'private'} style={{ fontSize: '14px' }}>
                Private
              </MenuItem>
              <MenuItem value={'shared'} style={{ fontSize: '14px' }}>
                Shared
              </MenuItem>
            </Select>
          </FormControl>
        </div>
        <div style={{ display: 'flex', flexFlow: 'column', gap: '15px' }}>
          <TableContainer style={{ border: '1px solid #e3e3e3', borderRadius: '5px' }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead stickyHeader>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} style={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {fileList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((column) => {
                  return (
                    <TableRow hover role="checkbox">
                      <TableCell size="small">{column.name}</TableCell>
                      <TableCell size="small">
                        {column.type === 'private' ? (
                          <Chip
                            label="Private"
                            variant="outlined"
                            size="small"
                            className="private-chip"
                            onClick={() => {
                              setOpenShare(true)
                              setSelectedFile(column)
                            }}
                          />
                        ) : column.type === 'public' ? (
                          <Chip label="Public" variant="outlined" size="small" className="public-chip" />
                        ) : (
                          <div style={{ display: 'flex', gap: '5px' }}>
                            <Chip
                              label="Shared"
                              variant="outlined"
                              size="small"
                              className="shared-chip"
                              onClick={() => {
                                setSelectedFile(column)
                                setSharedUsers(column.shared_list)
                                setOpenList(true)
                              }}
                            />
                            {/*<Tooltip title="Users List" placement="right" arrow>
                          <IconButton
                          size='small'
                          style={{color:'#f4a103',alignSelf:'center'}} 
                          onClick={()=>{setSelectedFile(column);setSharedUsers(column.shared_list);setOpenList(true)}}>
                            <ListAltIcon />
                          </IconButton>
                          </Tooltip>*/}
                          </div>
                        )}
                      </TableCell>
                      <TableCell size="small">
                        {/*column.type === 'private'? (
                          <Tooltip title="Share" placement="top" arrow>
                            <IconButton
                              style={{ marginRight: '10px', color: '#03a9f4' }}
                              size="small"
                              onClick={() => {
                                setOpenShare(true)
                                setSelectedFile(column)
                              }}
                            >
                              <ShareIcon />
                            </IconButton>
                          </Tooltip>
                        ) : null*/}

                        <IconButton
                          aria-label="delete"
                          size="small"
                          style={{ color: '#d32f2f' }}
                          onClick={() => {
                            setOpenDelete(true)
                            setSelectedFile(column)
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell size="small">
                        <Checkbox
                          color="primary"
                          onChange={(e) => handleToggle(column.selected, column.id)}
                          checked={column.selected}
                        />
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ background: '#fafafa' }}
              rowsPerPageOptions={[5, 10, 20]}
              component="div"
              count={fileList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>

          {loading ? (
            <div style={{ width: '100%', display: 'flex', height: '29px' }}>
              <div style={{ margin: 'auto', alignSelf: 'center', color: '#03a9f4' }}>
                <label style={{ marginRight: '10px' }}>Loading</label>
                <Spin
                  style={{ alignSelf: 'center', color: '#03a9f4' }}
                  // tip="Loading..."
                  size="middle"
                  indicator={<LoadingOutlined />}
                ></Spin>
              </div>
            </div>
          ) : (
            <button className="files-manager-btn-download" onClick={() => downloadFiles()}>
              DOWNLOAD
            </button>
          )}
          {alerta.bool ? <Alert severity="warning">{alerta.message}</Alert> : null}
        </div>
        <ShareDialog
          openShare={openShare}
          setOpenShare={setOpenShare}
          selectedFile={selectedFile}
          userList={userList}
          getFiles={getFiles}
        />
        <DeleteDialog
          openDelete={openDelete}
          setOpenDelete={setOpenDelete}
          selectedFile={selectedFile}
          getFiles={getFiles}
        />
        <UsersListDialog
          openList={openList}
          setOpenList={setOpenList}
          userList={userList}
          selectedFile={selectedFile}
          sharedUsers={sharedUsers}
          setSharedUsers={setSharedUsers}
          getFiles={getFiles}
        />
      </div>
    )
  } else {
    return (
      <div className="save-file-modal" style={{ width: '556px' }}>
        <div style={{ height: '156px', width: '100%', display: 'grid' }}>
          <Spin
            style={{ margin: 'auto', alignSelf: 'center', color: '#03a9f4' }}
            tip="Loading..."
            size="large"
            indicator={<LoadingOutlined />}
          ></Spin>
        </div>
      </div>
    )
  }
}

export default SavedFiles
